import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { Icon, IconName, IconColor } from 'app/common/components/controls';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from './AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'dialog']);
interface RemoveEmailsProps {
  aaEmail: string;
  otherEmails: string[];
  orgName: string;
  onClickRemoveEmails: () => void;
  onDismiss: () => void;
  image?: HTMLImageElement;
}

export const RemoveEmails: FunctionComponent<RemoveEmailsProps> = ({
  aaEmail,
  otherEmails,
  orgName,
  onClickRemoveEmails,
  onDismiss,
  image,
}) => {
  const emailCount = otherEmails.length;
  return (
    <OnboardingDialog
      closeDialog={onDismiss}
      title={format('lets set up your account')}
      helpLink={AtlassianAccountOnboardingLinks.Help}
      image={image}
    >
      <p>
        {format('multi email managed account message', {
          org: orgName,
        })}
      </p>
      <div className={styles.section}>
        <Icon
          color={IconColor.Green}
          name={IconName.Check}
          className={styles.inlineIcon}
        />
        <strong>{format('primary email message')}</strong>
      </div>
      <div className={styles.primaryEmail}>{aaEmail}</div>
      <div className={styles.section}>
        <Icon
          color={IconColor.Gray}
          name={IconName.Close}
          className={styles.inlineIcon}
        />
        <strong>
          {format('we will remove all other emails', { emailCount })}
        </strong>
      </div>
      {otherEmails.map((email, index) => (
        <div key={index} className={styles.secondaryEmail}>
          {email}
        </div>
      ))}
      <PrimaryButton onClick={() => onClickRemoveEmails()}>
        {format('remove emails and finish account setup')}
      </PrimaryButton>
    </OnboardingDialog>
  );
};
